import {
	FlexButton,
	MimaButton,
	MimaDropdown,
	MimaInput,
	MimaText,
	Modal,
	ReceiptCheckBox as RCB,
} from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import { employeeStore, payrollStore } from '../../stores';
import successImg from '../../assets/img/Successful.png';
import { MdOutlineInfo } from 'react-icons/md';
import { Formik } from 'formik';
import { toJS } from 'mobx';
import React from 'react';

const ManagePayroll = ({
	closeModal,
	configureSuccess,
	showConfigureSuccess,
	loading,
	onSubmit,
	validationSchema,
	newConfig,
	showNewConfig,
	showOldConfig,
	editConfig,
	uploaded,
	file,
	selectClick,
	showEditConfig,
	onUpdateSubmit,
	goBack,
}) => {
	const configs = payrollStore.productSalesList;
	const {
		point,
		name,
	} = payrollStore?.selectedProductSale;
	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<>
				<MimaText variant="subtitle" align="center" mb={4}>
					Products Sales Config
				</MimaText>
				<div className={styles.beneficiary}>
					<div
						className={`${
							!newConfig
								? styles.beneficiary__saved
								: styles.beneficiary__saved_b
						}`}
						onClick={showOldConfig}
					>
						Products List
					</div>
					<div
						className={`${
							!newConfig ? styles.beneficiary__new : styles.beneficiary__new_b
						}`}
						onClick={showNewConfig}
					>
						Add New Products Lists
					</div>
				</div>

				{newConfig && !editConfig && !configureSuccess && (
					<>
						<MimaText variant="subtitle" mb={3}>
				Upload Product List Sheet
			</MimaText>
			{!uploaded && (
				<>
					<MimaText
						variant="small"
						mb={2}
						width={38}
						align="center"
						color="var(--color-primary)">
						To add your product list sheet in bulk kindly click the button below and
						download our excel template.
					</MimaText>

					<a
						href="https://res.cloudinary.com/mima-business/raw/upload/v1671005835/Production/Docs/productSales_w7f6ty.xlsx"
						target="_blank" rel="noreferrer">
						<MimaButton
							title="Download Template"
							variant="colorable"
							buttonColor="var(--color-dark)"
							mb={5}
						/>
					</a>

					<MimaText
						variant="small"
						mb={2}
						width={38}
						align="center"
						color="var(--color-primary)">
						Fill the downloaded template with your product list information and then
						upload in the next button
					</MimaText>
					<Formik
						initialValues={{
						}}
						onSubmit={onSubmit}>
						{({
							handleChange,
							handleBlur,
							handleSubmit,
							setFieldValue,
							values,
							errors,
							touched,
						}) => (
							<>
								<MimaButton
									title="Select file"
									variant="outlined"
									width={38}
									onClick={selectClick}
								/>
								<MimaText
									variant="small"
									mt={2}
									width={38}
									align="center"
									color="var(--color-primary)">
									{file?.name || ''}{' '}
								</MimaText>

								<MimaButton
									disabled={loading}
									loading={loading}
									title="Upload Product List Sheet"
									type="submit"
									onClick={handleSubmit}
								/>
							</>
						)}
					</Formik>
				</>
			)}
			{uploaded && (
				<>
					<img
						src={successImg}
						alt="Upload success"
						className={styles.success}
					/>
					<MimaText
						variant="h3"
						width={38}
						align="center"
						color="var(--color-success)"
						mb={2}>
						Upload <br />
						Successful
					</MimaText>
					{/* <MimaText width={38} align="center" color="var(--color-primary)">
						You successfully uploaded 35 employees
					</MimaText> */}
					<MimaButton title="Continue" onClick={closeModal} mt={3} />
				</>
			)}
					</>
				)}

				{!newConfig && !editConfig && !configureSuccess && (
					<>
						<MimaText variant="smallBold" align="center" mb={1}>
							Product Sales List
						</MimaText>

						{configs.length > 0 ? (
							<div className="whiteTable">
								<table>
									<thead>
										<tr>
											<th>Name</th>
											<th>Identifier</th>
											<th>Points</th>
											<th>Action</th>
										</tr>
									</thead>

									<tbody>
										{configs.map(config => (
											<tr>
												<td>
													{ config.name }
												</td>
												<td>{ config.identifier }</td>
												<td>{ config.point }</td>
												<td
													className={styles.cpt_action}
													onClick={() => {
														payrollStore.setSelectedProductSale(config);
														showEditConfig();
													}}
												>
													Edit
												</td>
											</tr>
										))}
									</tbody>
								</table>
								<MimaButton
									title="Add More Product List"
									onClick={showNewConfig}
									mt={3}
								/>
							</div>
						) : (
							<>
								<MimaText align="center">
									No Product Sales List
								</MimaText>
								<MimaButton
									title="Set a configuration"
									onClick={showNewConfig}
								/>
							</>
						)}
					</>
				)}

				{editConfig && (
					<>
						<MimaText variant="smallBold" align="center" mb={1}>
							{`Edit ${ name } Configuration`}
						</MimaText>

						<Formik
							initialValues={{
								point,
							}}
							validationSchema={validationSchema}
							onSubmit={onUpdateSubmit}
						>
							{({
								handleChange,
								handleBlur,
								handleSubmit,
								setFieldValue,
								values,
								errors,
								touched,
							}) => (
								<div>
									<MimaInput
										type="number"
										min={1}
										max={31}
										labelTitle="Point"
										name="point"
										id="point"
										error={errors.point}
										touched={touched.point}
										value={values.point}
										onChange={handleChange}
										onBlur={handleBlur}
									/>
									<MimaButton
										title="Submit"
										loading={loading}
										type="submit"
										onClick={handleSubmit}
										mt={2}
									/>
								</div>
							)}
						</Formik>
					</>
				)}
			</>
		</Modal>
	);
};

export default ManagePayroll;
